module.exports = __webpack_public_path__ + "static/img/pending.44d6f825.svg";